import { routerReducer } from 'react-router-redux';
import general from './GeneralReducer';
import flights from './FlightsReducer';
import relationshipTypes from './RelationshipTypesReducer';
import passenger from './PassengerReducer';
import passengers from './PassengersReducer';
import global from './GlobalReducer';
import devAuth from './DevAuthReducer';
import routes from './RoutesReducer';
import allFlights from './AllFlightsReducer';
import terms from './TermsReducer';
import navigation from './NavigationReducer';

export default {
  routing: routerReducer,
  general,
  flights,
  global,
  devAuth,
  routes,
  allFlights,
  relationshipTypes,
  passenger,
  passengers,
  terms,
  navigation,
};



// WEBPACK FOOTER //
// ./src/redux/reducers/Index.js